var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.has_no_edit_material)?_c('div',{staticClass:"material-page"},[_c('div',{staticClass:"material-page-content"},[_c('span',[_vm._v("您的素材待修改快去看看吧")]),_c('el-button',{staticStyle:{"margin-left":"20px"},attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleClick}},[_vm._v("立即查看")])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }